module.exports = __webpack_public_path__ + "img/logo.bba7000e.svg";